import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductPage from './pages/ProductPage';
import Checkout from './pages/Checkout';
import './App.css';

// Lazy load Master Admin pages to isolate them from main bundle
const MasterLogin = lazy(() => import('./pages/Master/Login'));
const MasterDashboard = lazy(() => import('./pages/Master/Dashboard'));

function App() {
  return (
    <>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/product/:productId" element={<ProductPage />} />
          <Route path="/checkout" element={<Checkout />} />

          {/* Internal Control Routes — Hidden from standard navigation */}
          <Route path="/vyera-inventory-control" element={<MasterLogin />} />
          <Route path="/vyera-inventory-control/dashboard" element={<MasterDashboard />} />
        </Routes>
      </Suspense>
      <CartDrawer />
    </>
  );
}

export default App;
